// This file is auto-generated. Do not edit directly.
// Generated from configuration/groups/autonomy/practitioner-mappings.yaml
// Run: bun run scripts/mappings/autonomy-make-practitioner-mappings-from-yaml.ts
import { PractitionerMapping } from "@/configuration/practitioner-mappings/types";

export const AUTONOMY_PRACTITIONER_MAPPINGS: Partial<Record<string, PractitionerMapping>> = {
  "1023083961": {
    npiNumber: "1023083961",
    firstName: "Daragh",
    lastName: "Heitzman",
    location: "",
    locationEhrId: "",
    ma: "Stephanie Lopez",
    supervisorLeadMa: "Faye Robbins",
    botoxSpecialist: "Bella Segovia-Kizillar"
  },
  "1053811075": {
    npiNumber: "1053811075",
    firstName: "Paige",
    lastName: "Stafford",
    location: "",
    locationEhrId: "",
    ma: "Vashti Padilla",
    supervisorLeadMa: "",
    botoxSpecialist: "Jeannie Rodriguez"
  },
  "1184250987": {
    npiNumber: "1184250987",
    firstName: "Eslin",
    lastName: "Luka",
    location: "",
    locationEhrId: "",
    ma: "Lisa Gonzalez",
    supervisorLeadMa: "Nicole Dunlap",
    botoxSpecialist: "Bella Segovia-Kizillar"
  },
  "1316478373": {
    npiNumber: "1316478373",
    firstName: "Adam",
    lastName: "Sheffield",
    location: "",
    locationEhrId: "",
    ma: "Jacqueline Soto",
    supervisorLeadMa: "Nicole Dunlap"
  },
  "1386434090": {
    npiNumber: "1386434090",
    firstName: "Kaylah",
    lastName: "Brown",
    location: "",
    locationEhrId: "",
    ma: "Jessica Martinez",
    supervisorLeadMa: "",
    botoxSpecialist: "Jeannie Rodriguez"
  },
  "1427446566": {
    npiNumber: "1427446566",
    firstName: "Miles",
    lastName: "Horton",
    location: "",
    locationEhrId: "",
    ma: "Celeste Higareda",
    supervisorLeadMa: "",
    botoxSpecialist: "Bella Segovia-Kizillar"
  },
  "1447771167": {
    npiNumber: "1447771167",
    firstName: "Ashley",
    lastName: "Olsin",
    location: "",
    locationEhrId: "",
    ma: "Sarah Lansford",
    supervisorLeadMa: "",
    botoxSpecialist: "Bella Segovia-Kizillar"
  },
  "1528033362": {
    npiNumber: "1528033362",
    firstName: "Waleed",
    lastName: "El-Feky",
    location: "",
    locationEhrId: "",
    ma: "Lisa Gonzalez",
    supervisorLeadMa: "Nicole Dunlap",
    botoxSpecialist: "Bella Segovia-Kizillar"
  },
  "1619943362": {
    npiNumber: "1619943362",
    firstName: "Alan",
    lastName: "Martin",
    location: "",
    locationEhrId: "",
    ma: "Shema Ford",
    supervisorLeadMa: "Faye Robbins",
    botoxSpecialist: "Bella Segovia-Kizillar"
  },
  "1700037603": {
    npiNumber: "1700037603",
    firstName: "Raphael",
    lastName: "Schiffmann",
    location: "",
    locationEhrId: "",
    ma: "Sarah Lansford",
    supervisorLeadMa: "Faye Robbins"
  },
  "1740688555": {
    npiNumber: "1740688555",
    firstName: "Lauren",
    lastName: "Siniscalchi",
    location: "",
    locationEhrId: "",
    ma: "Abigail De La Rosa",
    supervisorLeadMa: "",
    botoxSpecialist: "Jeannie Rodriguez"
  },
  "1821298399": {
    npiNumber: "1821298399",
    firstName: "Gincy",
    lastName: "Samuel",
    location: "",
    locationEhrId: "",
    ma: "Elizabeth Dees",
    supervisorLeadMa: "Ana Ortiz",
    botoxSpecialist: "Jeannie Rodriguez"
  },
  "1841429057": {
    npiNumber: "1841429057",
    firstName: "Maria",
    lastName: "Philip",
    location: "",
    locationEhrId: "",
    ma: "Brandy Murray",
    supervisorLeadMa: "Faye Robbins"
  },
  "1861786576": {
    npiNumber: "1861786576",
    firstName: "Arun",
    lastName: "Nagaraj",
    location: "",
    locationEhrId: "",
    ma: "Stephanie Luna",
    supervisorLeadMa: "Nicole Dunlap",
    botoxSpecialist: "Bella Segovia-Kizillar"
  },
  "1942682653": {
    npiNumber: "1942682653",
    firstName: "Rabia",
    lastName: "Jamy",
    location: "",
    locationEhrId: "",
    ma: "Vanessa Montoya",
    supervisorLeadMa: "Ana Ortiz"
  },
  "1972579449": {
    npiNumber: "1972579449",
    firstName: "Steven",
    lastName: "Herzog",
    location: "",
    locationEhrId: "",
    ma: "Judith Alvarado",
    supervisorLeadMa: "Ana Ortiz",
    botoxSpecialist: "Bella Segovia-Kizillar"
  },
};
